import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MasipService } from '../../services/masip.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmationComponent } from '../../dialogs/delete-confirmation/delete-confirmation.component';
import { FormControl } from '@angular/forms';
import { get } from 'http';



@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrl: './profile-details.component.scss',
  standalone: false
})
export class ProfileDetailsComponent {
  @Input() deatails: boolean = false;
  @Input() profile: any;
  @Output() changeDetails = new EventEmitter<boolean>();

  isEdit: boolean = false;
  isCreate: boolean = false;
  showProfileConfiguration: boolean = false;
  isBasicInfo: boolean = true;
  asociatedLines: boolean = true;
  loading: boolean = false;

  associatedIp: string = '';
   date = new FormControl(new Date());

  numberofLines: number = 0;
  settings: any[] = [];
  lines: any[] = [];

  loadingApi: any;
  name: any;

  constructor(
    private masipService: MasipService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadingApi = false;
    this.loading = true;

    if (this.profile === undefined) {
      this.isCreate = true;
      this.getBaseConfigurations();
    } else {
      this.settings = JSON.parse(this.profile.configuration);
      this.numberofLines = this.profile.lines.length;
    }

  }


  closeDetails() {
    this.deatails = !this.deatails;
    this.changeDetails.emit(this.deatails);

  }

  editLine() {
    this.isEdit = true;
  }

  getSettings(event: any) {
    this.settings = event;
    console.log(this.settings);
    
  }

   getBaseConfigurations() {
      this.masipService.getBaseConfigurations().subscribe(resp => {
        this.settings = resp;
        var ipData = this.settings.find(e => e.featureID == 'IPv4EndUserAddress');
        if (ipData.active == 'true' && ipData.extString != null) {
          this.associatedIp = ipData.extString;
        }
        var ipData = this.settings.find(e => e.featureID == 'LastUpdateLocation');
        if (ipData.extString != null) {
          this.date = new FormControl(new Date(ipData.extString));
        }
  
        this.loading = false;
     
      }, error => {
  
        this.loading = false;
      
      })
    }
  

  saveLine() {

    // this.isEdit = false;
    var fiscalId = '';
    if (localStorage.getItem('accessAsUser') !== null) {
      fiscalId = String(localStorage.getItem('accessAsUser') || '');
    }

    if (this.isCreate) {
      

      const payload = {
        name: this.name,
        fiscal_id: fiscalId,
        configuration: this.settings
      }
      this.masipService.postProfileConfiguration(payload).subscribe((resp: any) => {

        this.closeDetails();
      }
      );
    }
    if (this.isEdit) {
      const payload = {
        name: this.profile.name,
      }
      this.masipService.putProfileConfiguration(this.profile.id, payload).subscribe((resp: any) => {

        this.closeDetails();
      });
    }

  }

  deleteProfile() {
    
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      width: 'fit-content',
      height: 'fit-content',
     maxWidth: '500px',
      data: { profile: this.profile }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      
      if (result === 'eliminado') {
        this.closeDetails();
      }
    });
  }

  openConfiguration() {
    this.showProfileConfiguration = true;
  }

  closeConfiguration(nuevoEstado: boolean) {
    this.showProfileConfiguration = nuevoEstado;

  }

  basicInfo() {
    this.isBasicInfo = true;
    this.asociatedLines = false;
  }

  associatedLines() {
    this.isBasicInfo = false;
    this.asociatedLines = true;
  }

  unassociatedLine() {
    this.isBasicInfo = false;
    this.asociatedLines = false;
  }

  getLinesSelected(event: any[]) {
    this.lines = event;

  }

  cancelEdit() {
    this.isEdit = false;
    this.name = this.profile.name;
  }

  updateProfileLines() {
    this.masipService.setApiLoadingGlobal(true);
    let payload = {
      phone_numbers: this.lines
    }
    this.masipService.updateProfileLines(this.profile.id, payload).subscribe((resp: any) => {
      this.masipService.setApiLoadingGlobal(false);
      this.basicInfo();
      this.closeConfiguration(false);
      this.closeDetails();
    });
  }
}
